<script lang="ts" setup>
import {
  GetMessageDocument,
  type Message,
} from '~/utils/generated/graphql'
import { getItemImageUrl } from '~/utils/graphql/graphql'
import { useGraphQuery } from '~/utils/graphql/client'

const route = useRoute()

const { locale } = useI18n()
const { data, error, refresh } = await useGraphQuery(GetMessageDocument, { slug: route.params.slug, locale: locale })
const message = computed(() => data.value?.contentItem as Message | null | undefined)
const pageTitle = computed(() => message.value?.title || '')
const pageDescription = computed(() => message.value?.description)

useHead({
  title: message.value?.title,
})

useSeoMeta({
  title: pageTitle,
  ogTitle: pageTitle,
  description: pageDescription,
  ogDescription: pageDescription,
  ogImage: computed(() => getItemImageUrl(message.value)),
  ogUrl: 'https://passionequip.com/talks/' + route.params.slug,
})
</script>

<template>
  <PageContent
    v-if="message"
    disable-top-padding
  >
    <ContentItemHeader :item="message" />
    <article class="prose prose-xl dark:prose-invert ps-4 pe-4 m-auto">
      <div
        class="mb-8 rounded-lg overflow-hidden ms-4 me-4 lg:ms-0 lg:me-0"
      >
        <ContentMedia :media="message" />
      </div>
      <div>
        <ContentComponents
          :item="message"
          :add-margin="true"
          :components="message.components || []"
        />
      </div>
      <hr class="mt-8 mb-8">
      <ContentAuthor :item="message" />
    </article>
  </PageContent>
  <ContentError
    v-else-if="error"
    :refresh="refresh"
  />
</template>
